import React, { Component } from "react";
import {
  NormalButton,
  NormalSelect,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalTextarea,
  InputSearch,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import { withTranslation } from "react-i18next";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ItemSitelists } from "redux/actions/Backend";
import {
  commonCreateApi,
  commonUpdateApi,
  getCommonApi,
} from "redux/actions/common";
import { Toast } from "service/toast";

export class EinvoiceSetupClass extends Component {
  state = {
    companyName: "",
    regNo: "",
    tin: "",
    environment: "SANDBOX", // This now controls which tab is active
    // Separate credentials for each environment
    sandboxCredentials: {
      clientId: "",
      clientSecret1: "",
      clientSecret2: "",
    },
    liveCredentials: {
      clientId: "",
      clientSecret1: "",
      clientSecret2: "",
    },
    intermediaryTin: "",
    intermediaryBrn: "",
    intermediaryName: "",
    // Separate visibility toggles for each environment
    sandboxVisibility: {
      showClientId: false,
      showClientSecret1: false,
      showClientSecret2: false,
    },
    liveVisibility: {
      showClientId: false,
      showClientSecret1: false,
      showClientSecret2: false,
    },
    siteOptions: [],
    selectedSite: "",
    is_loading: false,
    existingData: null,
    isUpdateMode: false,
  };

  componentDidMount = () => {
    this.Listofsitelist();
  };

  Listofsitelist = async () => {
    this.setState({ is_loading: true });
    await this.props.ItemSitelists().then((res) => {
      let { siteOptions } = this.state;
      for (let key of res) {
        siteOptions.push({
          value: key.itemsiteCode,
          label: key.itemsiteDesc,
          id: key.itemsiteId,
        });
      }
      this.setState({
        siteOptions,
        is_loading: false,
      });
    });
  };

  validateUUIDFormat = (value) => {
    const uuidRegex =
      /^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/;
    return uuidRegex.test(value);
  };

  formatClientId = (value) => {
    const alphanumeric = value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 32);
    return alphanumeric.replace(
      /^(.{8})(.{0,4})(.{0,4})(.{0,4})(.{0,12}).*/,
      (match, p1, p2, p3, p4, p5) =>
        [p1, p2, p3, p4, p5].filter(Boolean).join("-")
    );
  };

  // Updated to handle environment-specific credentials
  handleInputChange = (field, value, environment = null) => {
    if (
      environment &&
      (field === "clientId" ||
        field === "clientSecret1" ||
        field === "clientSecret2")
    ) {
      const formattedValue = this.formatClientId(value);
      this.setState((prevState) => ({
        [`${environment}Credentials`]: {
          ...prevState[`${environment}Credentials`],
          [field]: formattedValue,
        },
      }));
    } else {
      this.setState({ [field]: value });
    }
  };

  handleEnvironmentChange = (env) => {
    this.setState({ environment: env });
  };

  // Updated to handle environment-specific visibility
  toggleVisibility = (field, environment) => {
    this.setState((prevState) => ({
      [`${environment}Visibility`]: {
        ...prevState[`${environment}Visibility`],
        [field]: !prevState[`${environment}Visibility`][field],
      },
    }));
  };

  validateForm = () => {
    const { sandboxCredentials, liveCredentials } = this.state;
    let errors = [];

    // Validate sandbox credentials if any are filled
    if (sandboxCredentials?.clientId) {
      const sandboxFields = Object.entries(sandboxCredentials);
      sandboxFields.forEach(([key, value]) => {
        if (value && !this.validateUUIDFormat(value)) {
          errors.push(`Sandbox ${key}`);
          Toast({
            type: "error",
            message: `Sandbox ${key} must follow the format: 12345678-1234-1234-1234-123456789012`,
          });
        }
      });
    }

    // Validate live credentials if any are filled
    if (liveCredentials?.clientId) {
      const liveFields = Object.entries(liveCredentials);
      liveFields.forEach(([key, value]) => {
        if (value && !this.validateUUIDFormat(value)) {
          errors.push(`Live ${key}`);
          Toast({
            type: "error",
            message: `Live ${key} must follow the format: 12345678-1234-1234-1234-123456789012`,
          });
        }
      });
    }
    return errors.length === 0;
  };

  handleRegisterERP = () => {
    if (!this.validateForm()) {
      return;
    }

    const {
      companyName,
      tin,
      regNo,
      selectedSite,
      siteOptions,
      isUpdateMode,
      sandboxCredentials,
      liveCredentials,
      environment,
    } = this.state;

    // Create payload with separate environment credentials
    const payload = {
      company: companyName,
      tin: tin,
      reg_no: regNo,
      site_code:
        selectedSite !== ""
          ? selectedSite
          : siteOptions?.map((list) => list.value),
      is_live: environment === "Live" ? true : false,
      environment: {
        sandbox: {
          client_id: sandboxCredentials.clientId,
          client_secret1: sandboxCredentials.clientSecret1,
          client_secret2: sandboxCredentials.clientSecret2,
        },
        live: {
          client_id: liveCredentials.clientId,
          client_secret1: liveCredentials.clientSecret1,
          client_secret2: liveCredentials.clientSecret2,
        },
      },
    };

    const apiMethod = isUpdateMode
      ? this.props.commonUpdateApi
      : this.props.commonCreateApi;
    const apiEndpoint = isUpdateMode
      ? `einvoicebackend/${this.state.existingData.id}/`
      : "einvoicebackend/";

    apiMethod(apiEndpoint, payload).then((res) => {
      console.log(res, "response");
      this.handleGetERP();
    });

    console.log(
      `${isUpdateMode ? "Update" : "Register"} ERP Payload:`,
      payload
    );
  };

  handleGetERP = async () => {
    const { selectedSite } = this.state;
    this.props
      .getCommonApi(`einvoicebackend/?site_code=${selectedSite}`)
      .then((res) => {
        console.log(res, "getRes");

        if (res && res.length > 0) {
          const existingData = res[0];
          this.setState({
            existingData: existingData,
            isUpdateMode: true,
            companyName: existingData.company || this.state.companyName,
            tin: existingData.tin || this.state.tin,
            regNo: existingData.reg_no || this.state.regNo,
            // Populate separate environment credentials
            sandboxCredentials: {
              clientId: existingData.environment?.sandbox?.client_id || "",
              clientSecret1:
                existingData.environment?.sandbox?.client_secret1 || "",
              clientSecret2:
                existingData.environment?.sandbox?.client_secret2 || "",
            },
            liveCredentials: {
              clientId: existingData.environment?.live?.client_id || "",
              clientSecret1:
                existingData.environment?.live?.client_secret1 || "",
              clientSecret2:
                existingData.environment?.live?.client_secret2 || "",
            },
          });
        } else {
          this.setState({
            existingData: null,
            isUpdateMode: false,
          });
        }
      });
  };

  handleSiteChange = (value) => {
    this.setState({ selectedSite: value }, () => {
      if (value) {
        this.handleGetERP();
      }
    });
  };

  handleTestIntermediary = () => {
    console.log("Test Intermediary clicked");
  };

  // Helper method to render credentials form for a specific environment
  renderCredentialsForm = (envType) => {
    const credentials = this.state[`${envType}Credentials`];
    const visibility = this.state[`${envType}Visibility`];
    const envLabel = envType === "sandbox" ? "SANDBOX" : "Live";

    return (
      <div className="credentials-section">
        <div className="form-row">
          <label className="form-label">Client ID</label>
          <div className="input-with-toggle">
            <NormalInput
              type={visibility.showClientId ? "text" : "password"}
              value={credentials.clientId}
              onChange={(e) =>
                this.handleInputChange("clientId", e.target.value, envType)
              }
              maxLength="36"
              placeholder={`Enter ${envLabel} Client ID`}
            />
            <button
              type="button"
              className="toggle-visibility"
              onClick={() => this.toggleVisibility("showClientId", envType)}
            >
              👁
            </button>
          </div>
        </div>

        <div className="form-row">
          <label className="form-label">Client Secret 1</label>
          <div className="input-with-toggle">
            <NormalInput
              type={visibility.showClientSecret1 ? "text" : "password"}
              value={credentials.clientSecret1}
              onChange={(e) =>
                this.handleInputChange("clientSecret1", e.target.value, envType)
              }
              maxLength="36"
              placeholder={`Enter ${envLabel} Client Secret 1`}
            />
            <button
              type="button"
              className="toggle-visibility"
              onClick={() =>
                this.toggleVisibility("showClientSecret1", envType)
              }
            >
              👁
            </button>
          </div>
        </div>

        <div className="form-row">
          <label className="form-label">Client Secret 2</label>
          <div className="input-with-toggle">
            <NormalInput
              type={visibility.showClientSecret2 ? "text" : "password"}
              value={credentials.clientSecret2}
              onChange={(e) =>
                this.handleInputChange("clientSecret2", e.target.value, envType)
              }
              maxLength="36"
              placeholder={`Enter ${envLabel} Client Secret 2`}
            />
            <button
              type="button"
              className="toggle-visibility"
              onClick={() =>
                this.toggleVisibility("showClientSecret2", envType)
              }
            >
              👁
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    let {
      companyName,
      regNo,
      tin,
      environment,
      intermediaryTin,
      intermediaryBrn,
      intermediaryName,
      siteOptions,
      selectedSite,
      isUpdateMode,
    } = this.state;
    let { t } = this.props;

    return (
      <>
        <div className="einvoice-setup-container">
          <h5>E-Invoice Setup</h5>

          {/* Company Information Section */}
          <div className="form-section">
            <div className="form-row">
              <label className="form-label">Select Site</label>
              <NormalSelect
                options={siteOptions}
                value={selectedSite}
                onChange={(e) => this.handleSiteChange(e.target.value)}
                name="selectedSite"
              />
            </div>
            <div className="form-row">
              <label className="form-label">Company</label>
              <NormalInput
                value={companyName}
                onChange={(e) =>
                  this.handleInputChange("companyName", e.target.value)
                }
              />
            </div>

            <div className="form-row">
              <label className="form-label">Reg. No (New)</label>
              <NormalInput
                value={regNo}
                onChange={(e) =>
                  this.handleInputChange("regNo", e.target.value)
                }
              />
            </div>

            <div className="form-row">
              <label className="form-label">TIN</label>
              <NormalInput
                value={tin}
                onChange={(e) => this.handleInputChange("tin", e.target.value)}
              />
            </div>
          </div>

          {/* ERP Section with Environment Tabs */}
          <div className="form-section">
            <h6 className="section-title">ERP Configuration</h6>

            {/* Environment Tab Navigation */}
            <div className="form-row">
              <label className="form-label">Environment</label>
              <div className="environment-buttons">
                <button
                  className={`env-btn ${
                    environment === "SANDBOX" ? "active" : ""
                  }`}
                  onClick={() => this.handleEnvironmentChange("SANDBOX")}
                >
                  SANDBOX
                </button>
                <button
                  className={`env-btn ${
                    environment === "Live" ? "active" : ""
                  }`}
                  onClick={() => this.handleEnvironmentChange("Live")}
                >
                  Live
                </button>
              </div>
            </div>

            {/* Render credentials form based on selected environment tab */}
            {environment === "SANDBOX" && this.renderCredentialsForm("sandbox")}
            {environment === "Live" && this.renderCredentialsForm("live")}

            <div className="form-row col-12 d-flex justify-content-end">
              <button className="register-btn" onClick={this.handleRegisterERP}>
                {isUpdateMode ? "Update ERP" : "Register ERP"}
              </button>
            </div>
          </div>
        </div>

        {/* Intermediary Section */}
        {/* <div className="form-section">
            <h6 className="section-title">Intermediary</h6>

            <div className="intermediary-row">
              <div className="intermediary-col">
                <label className="form-label">TIN</label>
                <div className="input-with-copy">
                  <NormalInput
                    value={intermediaryTin}
                    onChange={(e) =>
                      this.handleInputChange("intermediaryTin", e.target.value)
                    }
                  />
             
                </div>
              </div>

              <div className="intermediary-col">
                <label className="form-label">BRN</label>
                <div className="input-with-copy">
                  <NormalInput
                    value={intermediaryBrn}
                    onChange={(e) =>
                      this.handleInputChange("intermediaryBrn", e.target.value)
                    }
                  />
              
                </div>
              </div>

              <div className="intermediary-col">
                <label className="form-label">Name</label>
                <div className="input-with-copy">
                  <NormalInput
                    value={intermediaryName}
                    onChange={(e) =>
                      this.handleInputChange("intermediaryName", e.target.value)
                    }
                  />
             
                </div>
              </div>
            </div>

            <div className="form-row col-12 d-flex justify-content-end">
              <button
                className="test-btn"
                onClick={this.handleTestIntermediary}
              >
                Test Intermediary
              </button>
            </div>
          </div> */}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ItemSitelists,
      commonCreateApi,
      getCommonApi,
      commonUpdateApi,
    },
    dispatch
  );
};

export const EinvoiceSetup = withTranslation()(
  connect(null, mapDispatchToProps)(EinvoiceSetupClass)
);
